import { useQuery } from "react-query";
import { MyMapClick } from "../types";
import { getPlaceName } from "../utils/belfius-clusters.utils";

export const usePlaceName = (mapClick: MyMapClick | undefined) => {
  return useQuery<string | undefined>([`placename`, mapClick], () => getPlaceName(mapClick));
};
